<template>
    <div class="section pt-1">
        <div class="wallet-card">
            <div class="balance">
                <div class="left">
                    <span class="title mal-text">FFR ലിസ്റ്റ്</span>
                    <h1 class="total text-primary mal-text">{{ unit.name_mal }}</h1>
                </div>
                <div class="right" v-if="permissions.update">
                    <a href="javascript:void(0);" class="button" @click="openAddModal">
                        <ion-icon name="add-outline"></ion-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <!-- Add/Edit Pledge Modal -->
    <div class="modal fade action-sheet" id="ffrModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ isEdit ? 'Edit' : 'Add New' }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label">Name</label>
                                <input type="text" class="form-control" v-model="name" placeholder="Name" autocomplete="off" />
                            </div>
                        </div>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label">Mobile Number</label>
                                <input type="text" class="form-control" v-model="mobile" placeholder="Mobile Number"
                                    autocomplete="off" @input="duplicateMsg = ''; duplicateDetails = null"
                                    @blur="checkMobileDuplicate" />
                                <div v-if="duplicateMsg" class="error-feedback mt-1" style="font-size:13px;">
                                    <div>{{ duplicateMsg }}</div>
                                    <div v-if="duplicateDetails">
                                        <div>{{ duplicateDetails.name }} — {{ duplicateDetails.district_name }}, {{ duplicateDetails.zone_name }}, {{ duplicateDetails.unit_name }} ({{ duplicateDetails.list_type }})</div>
                                        <a v-if="duplicateDetails.mobile" :href="'tel:' + duplicateDetails.mobile"
                                            style="color:red;text-decoration:underline;font-weight:600;">
                                            {{ duplicateDetails.mobile }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label">Suggested Amount</label>
                                <input type="number" class="form-control" v-model="suggested_amount" placeholder="Suggested Amount" autocomplete="off" />
                            </div>
                        </div>

                        <!-- Promote fields shown only on edit -->
                        <template v-if="isEdit">
                            <hr />
                            <p class="mal-text text-muted" style="font-size:13px;">തുക ലഭിച്ചാൽ ഇവിടെ ഫിൽ ചെയ്ത് Submit ചെയ്യുക:</p>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label">Enter Amount</label>
                                    <input type="number" class="form-control" v-model="collected_amount" placeholder="Amount Received" autocomplete="off" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label">Receipt Number</label>
                                    <select class="form-control custom-select" v-model="receipt_no">
                                        <option value="">---Select---</option>
                                        <option v-for="n in availableReceiptNumbers" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                </div>
                            </div>
                        </template>

                        <div class="form-group" v-if="message">
                            <div class="error-feedback">{{ message }}</div>
                        </div>
                        <div class="form-group basic">
                            <button v-if="isEdit && collected_amount && receipt_no" type="button" class="btn btn-success btn-block btn-lg mb-1"
                                :disabled="loading" @click="promotePledge">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span class="mal-text">Main List-ലേക്ക് Move ചെയ്യുക</span>
                            </button>
                            <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="loading" @click="savePledge">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>Save</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="listed-detail mt-2">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && pledges.total <= 0">
            ഇതുവരെ ആരെയും ചേർത്തിട്ടില്ല
        </h4>
    </div>

    <ul class="listview image-listview text inset mt-2" v-if="pledges.data && pledges.data.length">
        <li v-for="(pledge, index) in pledges.data" :key="pledge.id">
            <div class="item">
                <div class="in">
                    <div>
                        <b>{{ index + 1 }}. {{ pledge.name }}</b>
                        <footer>{{ pledge.mobile ? pledge.mobile : '' }}
                            | ₹{{ pledge.suggested_amount }}
                        </footer>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                        <span v-if="pledge.status === 'collected'" class="badge bg-success mal-text">Collected</span>
                        <span v-else class="badge bg-warning text-dark mal-text">Pending</span>
                        <div class="card-button" v-if="permissions.update">
                            <button type="button" class="btn btn-link btn-icon"
                                data-bs-toggle="modal" :data-bs-target="'#ffrAction' + pledge.id">
                                <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Action Sheet per item -->
            <div class="modal fade action-sheet" :id="'ffrAction' + pledge.id" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Action</h5>
                        </div>
                        <div class="modal-body">
                            <ul class="action-button-list">
                                <li>
                                    <a href="javascript:void(0);" class="btn btn-list" data-bs-dismiss="modal"
                                        @click="editPledge(pledge)">
                                        <span><ion-icon name="pencil-outline"></ion-icon> Edit</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" class="btn btn-list text-danger" data-bs-dismiss="modal"
                                        @click="confirmDelete(pledge)">
                                        <span><ion-icon name="trash-outline"></ion-icon> Remove</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>

    <vue-awesome-paginate v-if="pledges.last_page > 1" :total-items="pledges.total" :items-per-page="pledges.per_page"
        :max-pages-shown="3" v-model="currentPage" @click="getPledges" />

    <AlertModel ref="alert_model" :type="alert_type" :message="alert_message" />
    <DialogModel ref="dialog_model" :message="dialog_message" :action="dialog_action"
        :action_params="dialog_action_params" @confirmed="handleDialogConfirm" />
</template>

<script>
/* global bootstrap */
import AlertModel from './../layouts/AlertModel.vue';
import DialogModel from './../layouts/DialogModel.vue';
import UserService from '../../services/user.service';

export default {
    name: 'FfrList',
    components: { AlertModel, DialogModel },
    data() {
        return {
            loading: false,
            loading_list: false,
            message: '',
            pledges: {},
            ffrModal: null,
            unit: {},
            permissions: {},
            name: '',
            mobile: '',
            suggested_amount: '',
            collected_amount: '',
            receipt_no: '',
            isEdit: false,
            editable_id: null,
            availableReceiptNumbers: [],
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: {},
            currentPage: 1,
            duplicateMsg: '',
            duplicateDetails: null,
        };
    },
    mounted() {
        this.ffrModal = new bootstrap.Modal(document.getElementById('ffrModal'));
        this.getPledges();
    },
    methods: {
        checkMobileDuplicate() {
            const mobile = String(this.mobile || '').trim();
            if (mobile.length < 10) { this.duplicateMsg = ''; this.duplicateDetails = null; return; }
            UserService.authPostRequest('check-fund-pledge-mobile', {
                mobile,
                fund_type: parseInt(this.$route.params.type),
                editable_id: this.editable_id || null,
            }).then((response) => {
                const data = response.data && response.data.data;
                if (data && data.duplicate) {
                    this.duplicateDetails = data;
                    this.duplicateMsg = 'ഈ നമ്പർ ഇതിനകം ചേർത്തിട്ടുണ്ട്.';
                } else {
                    this.duplicateMsg = '';
                    this.duplicateDetails = null;
                }
            }).catch(() => { this.duplicateMsg = ''; this.duplicateDetails = null; });
        },
        getPledges(page = 1) {
            this.loading_list = true;
            UserService.authPostRequest(`get-fund-pledges?page=${page}`, {
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                list_type: 'ffr',
            }).then((response) => {
                this.loading_list = false;
                if (response.data.status === 'success') {
                    this.pledges = response.data.data.list;
                    this.unit = response.data.data.unit;
                    this.permissions = response.data.data.permissions;
                    this.$root.updateParent('FFR ലിസ്റ്റ് - ' + (this.unit.name_mal || ''));
                }
            }, () => { this.loading_list = false; });
        },
        loadAvailableReceiptNumbers(currentNo = null) {
            const data = {
                fund_type: parseInt(this.$route.params.type),
                unit_id: parseInt(this.$route.params.id),
            };
            if (currentNo) data.current_receipt_no = currentNo;
            UserService.authPostRequest('receipt-book/available-receipt-numbers', data).then((response) => {
                if (response.data.status === 'success') {
                    this.availableReceiptNumbers = response.data.data.numbers || [];
                }
            });
        },
        openAddModal() {
            this.resetForm();
            this.isEdit = false;
            this.ffrModal.show();
        },
        editPledge(pledge) {
            this.resetForm();
            this.isEdit = true;
            this.editable_id = pledge.id;
            this.name = pledge.name;
            this.mobile = pledge.mobile;
            this.suggested_amount = pledge.suggested_amount;
            this.loadAvailableReceiptNumbers(pledge.receipt_no);
            this.ffrModal.show();
        },
        resetForm() {
            this.name = '';
            this.mobile = '';
            this.suggested_amount = '';
            this.collected_amount = '';
            this.receipt_no = '';
            this.editable_id = null;
            this.message = '';
            this.duplicateMsg = '';
            this.duplicateDetails = null;
        },
        savePledge() {
            if (!this.name) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി പേര് ഫിൽ ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return;
            }
            if (!this.suggested_amount) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി തുക ഫിൽ ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return;
            }
            this.loading = true;
            UserService.authPostRequest('store-fund-pledge', {
                unit_id: parseInt(this.$route.params.id),
                fund_type: parseInt(this.$route.params.type),
                list_type: 'ffr',
                editable_id: this.editable_id,
                name: this.name,
                mobile: this.mobile,
                suggested_amount: this.suggested_amount,
            }).then((response) => {
                this.loading = false;
                if (response.data.status === 'success') {
                    this.ffrModal.hide();
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getPledges();
                } else {
                    this.message = response.data.message;
                }
            }, () => { this.loading = false; });
        },
        promotePledge() {
            if (!this.collected_amount || !this.receipt_no) {
                this.alert_type = 'Warning';
                this.alert_message = 'Amount and Receipt Number required.';
                this.$refs.alert_model.openModel();
                return;
            }
            this.loading = true;
            UserService.authPostRequest('promote-fund-pledge', {
                pledge_id: this.editable_id,
                amount: this.collected_amount,
                receipt_no: this.receipt_no,
            }).then((response) => {
                this.loading = false;
                if (response.data.status === 'success') {
                    this.ffrModal.hide();
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getPledges();
                } else {
                    this.message = response.data.message;
                }
            }, () => { this.loading = false; });
        },
        confirmDelete(pledge) {
            this.dialog_action_params = { id: pledge.id };
            this.dialog_message = 'ഈ എൻട്രി ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'deletePledge';
            this.$refs.dialog_model.openModel();
        },
        handleDialogConfirm(data) {
            if (this.dialog_action === 'deletePledge') {
                UserService.authPostRequest('delete-fund-pledge', data).then((response) => {
                    if (response.data.status === 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getPledges();
                    }
                });
            }
        },
    },
};
</script>

<style scoped>
.error-feedback { color: red; }
.listview { margin-bottom: 0; }
</style>
